import { Button, Chip, Text } from '@medly-components/core';
import styled from 'styled-components';

export const FiltersWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.8rem;

    & > ${Text.Style} {
        color: ${({ theme }) => theme.colors.grey[700]};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        gap: 1.6rem;
    }
`;

export const FilterChip = styled(Chip)`
    height: fit-content;
    margin: 0;
    padding: 0.6rem 1rem;
    border: none;
    background-color: ${({ theme }) => theme.colors.grey[300]};
    color: ${({ theme }) => theme.font.defaults.color};

    ${Text.Style} {
        font-weight: ${({ theme }) => theme.font.weights.Medium};
    }

    &&& svg {
        margin-left: 0.8rem;
        font-size: 1.6rem;
        * {
            fill: ${({ theme }) => theme.font.defaults.color};
        }
    }
`;

export const ClearAllButton = styled(Button).attrs({ hideUnderline: true, variant: 'flat' })`
    padding: 0;
`;
